'use client';

import { LegalPageShell } from 'Bomdisoft/shared/legal-page-shell';
import s from 'Bomdisoft/shared/legal-page-shell/styles.module.css';
import {
  gdprBreachBody,
  gdprBreachHeading,
  gdprContactBody,
  gdprErrorBody,
  gdprErrorLabel,
  gdprIntro,
  gdprLegalBasisBody,
  gdprLegalBasisHeading,
  gdprProcessHeading,
  gdprRightsBody,
  gdprRightsHeading,
  gdprSubprocessorsHeading,
  gdprSubSentryBody,
  gdprSubSentryLabel,
  gdprSubVercelBody,
  gdprSubVercelLabel,
  gdprTechnicalBody,
  gdprTechnicalLabel,
  legalContactHeading,
  legalEyebrow,
  legalLastUpdated,
  legalTitleGdpr,
  legalTitleGdprAccent,
} from 'Bomdisoft/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const EMAIL = 'support@bomdisoft.com';
const DPO = 'dpo@bomdisoft.com';

const GdprPage = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  return (
    <LegalPageShell eyebrow={legalEyebrow[language]} lede={legalLastUpdated[language]} testId='gdpr-page' title={legalTitleGdpr[language]} titleAccent={legalTitleGdprAccent[language]}>
      <section className={s.section}>
        <div className={s.content}>
          <p className={s.body}>{gdprIntro[language]}</p>
          <h2 className={s.sectionHeading}>{gdprProcessHeading[language]}</h2>
          <ul className={s.list}>
            <li>
              <span className={s.strong}>{gdprTechnicalLabel[language]}</span> , {gdprTechnicalBody[language]}
            </li>
            <li>
              <span className={s.strong}>{gdprErrorLabel[language]}</span> , {gdprErrorBody[language]}
            </li>
          </ul>
          <h2 className={s.sectionHeading}>{gdprLegalBasisHeading[language]}</h2>
          <p className={s.body}>{gdprLegalBasisBody[language]}</p>
        </div>
      </section>
      <section className={s.sectionAlt}>
        <div className={s.content}>
          <h2 className={s.sectionHeading}>{gdprSubprocessorsHeading[language]}</h2>
          <ul className={s.list}>
            <li>
              <span className={s.strong}>{gdprSubVercelLabel[language]}</span> , {gdprSubVercelBody[language]}
            </li>
            <li>
              <span className={s.strong}>{gdprSubSentryLabel[language]}</span> , {gdprSubSentryBody[language]}
            </li>
          </ul>
          <h2 className={s.sectionHeading}>{gdprRightsHeading[language]}</h2>
          <p className={s.body}>{gdprRightsBody[language].replace('{email}', DPO)}</p>
          <h2 className={s.sectionHeading}>{gdprBreachHeading[language]}</h2>
          <p className={s.body}>{gdprBreachBody[language]}</p>
          <h2 className={s.sectionHeading}>{legalContactHeading[language]}</h2>
          <p className={s.body}>{gdprContactBody[language].replace('{email}', EMAIL).replace('{dpo}', DPO)}</p>
        </div>
      </section>
    </LegalPageShell>
  );
};

export default GdprPage;
